import BUY_IT_AGAIN_CONSTANTS from './BuyItAgain.constants';

const initialState = {
  buyItAgainProducts: [],
  isLoading: false,
  pageProducts: [],
  totalProductsCount: 0,
  initialProductsLoaded: 0,
  isLoadingMore: false,
  isBIAPageProductsLoading: true,
  isBIAPageLoading: true,
  cd66Data: {},
  initialApiProductIdCount: 0,
};

// eslint-disable-next-line complexity
const BuyItAgainReducer = (state = initialState, action) => {
  switch (action.type) {
    case BUY_IT_AGAIN_CONSTANTS.BUY_IT_AGAIN_PRODUCTS_START:
      return { ...state, isLoading: true };
    case BUY_IT_AGAIN_CONSTANTS.BUY_IT_AGAIN_PRODUCTS_SUCCESS: {
      const alreadyNotSavedBiaProducts = state?.buyItAgainProducts?.filter(
        (products) => products?.categoryCode !== action?.payload?.categoryCode
      );
      if (
        state?.buyItAgainProducts?.length === 0 ||
        (state?.buyItAgainProducts?.length > 0 && alreadyNotSavedBiaProducts)
      ) {
        return {
          ...state,
          buyItAgainProducts: [...state.buyItAgainProducts, action.payload],
          isLoading: false,
        };
      }
      return {
        ...state,
        isLoading: false,
      };
    }
    case BUY_IT_AGAIN_CONSTANTS.SET_INITIAL_PRODUCTS_LOADED:
      return { ...state, initialProductsLoaded: action.payload };
    case BUY_IT_AGAIN_CONSTANTS.SET_BIA_PAGE_PRODUCTS: {
      const mergedItems = [...state.pageProducts, ...action.payload];
      const uniqueByKeyProducts = [
        ...new Map(mergedItems.map((item) => [item.uniqueId, item])).values(),
      ];
      return {
        ...state,
        pageProducts: uniqueByKeyProducts,
        isLoadingMore: false,
      };
    }
    case BUY_IT_AGAIN_CONSTANTS.SET_BIA_IS_LOADING_MORE:
      return {
        ...state,
        isLoadingMore: action.payload,
      };
    case BUY_IT_AGAIN_CONSTANTS.SET_BIA_TOTAL_PRODUCTS_COUNT:
      return {
        ...state,
        totalProductsCount: action.payload,
      };
    case BUY_IT_AGAIN_CONSTANTS.SET_BIA_INITIAL_API_ACTUAL_PRODUCTS_COUNT:
      return {
        ...state,
        initialApiProductIdCount: action.payload,
      };
    case BUY_IT_AGAIN_CONSTANTS.BUY_IT_AGAIN_PRODUCTS_FAILURE:
      return {
        ...state,
        isLoading: false,
      };
    case BUY_IT_AGAIN_CONSTANTS.SET_BIA_LOADING:
      return {
        ...state,
        isBIAPageProductsLoading: action.payload,
      };
    case BUY_IT_AGAIN_CONSTANTS.SET_BIA_PAGE_LOADING:
      return {
        ...state,
        isBIAPageLoading: action.payload,
      };
    case BUY_IT_AGAIN_CONSTANTS.RESET_BIA:
      return {
        ...initialState,
      };
    case BUY_IT_AGAIN_CONSTANTS.SET_CD66:
      return {
        ...state,
        cd66Data: { ...state.cd66Data, [action.payload.variantId]: action.payload.cd66 },
      };
    case BUY_IT_AGAIN_CONSTANTS.CLEAR_CD66:
      return {
        ...state,
        cd66Data: [],
      };
    case BUY_IT_AGAIN_CONSTANTS.SET_BIA_API_RESPONSE:
      return { ...state, biaApiResponse: action.payload };
    default:
      return state;
  }
};

export default BuyItAgainReducer;
